import { Header } from "./Header";
import { Footer } from "./Footer";
import { useSeo } from "../../lib/seo";

export const PageShell = ({ seo, children }) => {
  useSeo(seo);
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
};
